import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Keycloak from "keycloak-js";

const AuthContext = createContext();

let _keycloakInstance = null;

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [user, setUser] = useState(null);
  const tokenRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const keycloak = new Keycloak({
      url: process.env.REACT_APP_KEYCLOAK_URL,
      realm: process.env.REACT_APP_KEYCLOAK_REALM,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
      checkLoginIframe: false,
    });

    keycloak.init({ onLoad: "login-required" }).then((authenticated) => {
      _keycloakInstance = keycloak;
      setIsAuthenticated(authenticated);

      if (authenticated) {
        const tokenParsed = keycloak.tokenParsed;
        tokenRef.current = keycloak.token;

        setUser({
          name: tokenParsed?.given_name || tokenParsed?.name || "",
          email: tokenParsed?.email || "",
        });

        if (tokenParsed.app_role === "administrador") {
          setIsAdmin(true);
        }

        intervalRef.current = setInterval(() => {
          keycloak
            .updateToken(60)
            .then((refreshed) => {
              if (refreshed) {
                console.log("🔁 Token refreshed");
              }
              tokenRef.current = keycloak.token;
            })
            .catch(() => {
              console.error("❌ Refresh falló. Logout...");
              keycloak.logout({ redirectUri: window.location.origin });
            });
        }, 30000);
      }
    });

    // ✅ Limpiar el intervalo correctamente
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const logout = () => {
  if (_keycloakInstance) {
    _keycloakInstance.logout({ redirectUri: window.location.origin });
  }
};

  const value = {
    isAuthenticated,
    isAdmin,
    user,
    logout,
    getToken: () => tokenRef.current,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
export const getToken = () => _keycloakInstance?.token || null;
